module.exports = __webpack_public_path__ + "static/media/WechatIMG2291.b2408e7c.png";